import { useField } from 'remix-validated-form'
import { OptionType } from 'types/OptionType'

export type UseFormComboProps = {
  name: string
  onChange?: (option: OptionType) => void
}

export type UseFormComboReturn = {
  error: string | undefined
  onChangeHandler: (option: OptionType) => void
}

export function useFormCombo({ name, onChange }: UseFormComboProps): UseFormComboReturn {
  const { error, setTouched } = useField(name, {
    validationBehavior: { initial: `onSubmit`, whenTouched: `onSubmit`, whenSubmitted: `onSubmit` },
  })

  const onChangeHandler = (option: OptionType) => {
    setTouched(true)
    onChange?.(option)
  }

  return { error, onChangeHandler }
}
